export const initialState = {
  name: "",
  username: "",
  phoneNumber: "",
  emailAddress: "",
  horoscopeImage: "",
  idProofImage: "",
  photo1: "",
  photo2: "",
  photo3: "",
  termsAndCondition: false,
};
